export const handleOpenChat = () => {
    openLink("https://wa.me/5582991194936")
    //@ts-ignore
    gtag('event', 'Abrir chat');
    //@ts-ignore
    plausible('Abrir chat')
    //@ts-ignore
    clarity("event", "Abrir chat")
};
  
export const openLink = (url: string) => {
    let link = document.createElement("a")
    link.href = url
    link.target = "_blank"
    link.click()
}